import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["href", "aria-label"]
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "contact__lineone" }
const _hoisted_4 = { class: "title" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("a", {
    class: "contact",
    href: $props.link,
    "aria-label": $options.contactAriaLabel,
    target: "_blank"
  }, [
    ($options.contactPhotoFromBase64)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: _normalizeClass({
				contact__image: $options.contactHasPhoto,
				contact__icon: !$options.contactHasPhoto,
			}),
          alt: "",
          src: $options.contactPhotoFromBase64
        }, null, 10, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString($options.displayName), 1)
    ])
  ], 8, _hoisted_1))
}